/**
 * Convert seconds to HH:MM:SS format
 * @param d - Duration in seconds
 * @returns Formatted time string (HH:MM:SS)
 */
export function secondsToHms(d: number = 0): string {
  d = Number(d);
  const h = Math.floor(d / 3600);
  const m = Math.floor((d % 3600) / 60);
  const s = Math.floor(d % 60);
  return [
    h.toString().padStart(2, '0'),
    m.toString().padStart(2, '0'),
    s.toString().padStart(2, '0')
  ].join(':');
}